'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MVFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 12" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", { id: "mantine-b3977uv2a", d: "M0 0h16v12H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-j9s269ndu", d: "M0 0h10v6H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-k4pkunphz", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#mantine-b3977uv2a" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-k4pkunphz)" }, /* @__PURE__ */ React.createElement("path", { fill: "#C51918", fillRule: "nonzero", d: "M0 0h16v11a1 1 0 01-1 1H1a1 1 0 01-1-1V0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C51918", fillRule: "nonzero", d: "M0 0h16v12H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#017A38", stroke: "#017A38", d: "M12.5 3.5v5h-9v-5z" }), /* @__PURE__ */ React.createElement("g", { transform: "translate(3 3)" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-jvzlw1zcp", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#mantine-j9s269ndu" })), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#F9FAFA",
        fillRule: "nonzero",
        d: "M5.016 3.231c-.008 1.533 1.199 2.35 1.199 2.35-1.377.162-2.293-1.086-2.293-2.335 0-1.248 1.248-2.28 2.293-2.745 0 0-1.19 1.197-1.199 2.73z",
        mask: "url(#mantine-jvzlw1zcp)"
      }
    )))))
  );
}

export { MVFlag };
//# sourceMappingURL=MV.mjs.map
